import React from 'react';

import PropTypes from 'prop-types';

import { CommonButton, DiskBadgeWrap, IconWrap, SubmitButton } from './styles';
import { DiskBadge } from '../DiskBadge/DiskBadge';
import { Icon } from '../Icon/Icon';
import { Text } from '../Text/Text';

const PopupButton = (props) => {
    const getColor = () => {
        if (props.hasDiskBadgeIcon) {
            return 'darkGray';
        } else if (props.disabled) {
            return 'purpleRgba40';
        } else {
            return props.isAlertButton ? 'red' : 'purple';
        }
    };
    return (
        <>
            {props.type !== 'submit' && (
                <CommonButton
                    href={props.href ? props.href : null}
                    rel={props.rel ? props.rel : null}
                    title={props.title ? props.title : null}
                    target={props.target ? props.target : null}
                    id={props.id ? props.id : null}
                    data-testid={props.dataTestId ? props.dataTestId : null}
                    isAlertButton={props.isAlertButton}
                    onClick={(e) => {
                        if (props.onClick) {
                            props.onClick(e);
                        }
                    }}
                    disabled={props.disabled}
                    isCentered={props.isCentered}
                >
                    {props.hasDiskBadgeIcon ? (
                        <DiskBadgeWrap>
                            <DiskBadge iconName={props.iconName} variant={'secondary'} />
                        </DiskBadgeWrap>
                    ) : (
                        <IconWrap>
                            <Icon name={props.iconName} color={getColor()} size="24px" />
                        </IconWrap>
                    )}
                    <Text ellipsis color={getColor()}>
                        {props.text}
                    </Text>
                </CommonButton>
            )}
            {props.type === 'submit' && (
                <SubmitButton
                    id={props.id ? props.id : null}
                    type={props.type}
                    tabIndex={props.tabIndex}
                    form={props.buttonForm ? props.buttonForm : null}
                    isAlertButton={props.isAlertButton}
                    value={props.value}
                    onClick={(e) => {
                        if (props.onClick) {
                            props.onClick(e);
                        }
                    }}
                    disabled={props.disabled}
                >
                    {props.hasDiskBadgeIcon ? (
                        <DiskBadgeWrap>
                            <DiskBadge iconName={props.iconName} variant={'secondary'} />
                        </DiskBadgeWrap>
                    ) : (
                        <IconWrap>
                            <Icon name={props.iconName} color={getColor()} size="24px" />
                        </IconWrap>
                    )}
                    <Text ellipsis color={getColor()}>
                        {props.text}
                    </Text>
                </SubmitButton>
            )}
        </>
    );
};
export default PopupButton;

PopupButton.propTypes = {
    type: PropTypes.string,
    href: PropTypes.string,
    rel: PropTypes.string,
    title: PropTypes.string,
    target: PropTypes.string,
    id: PropTypes.string,
    dataTestId: PropTypes.string,
    isAlertButton: PropTypes.bool,
    onClick: PropTypes.func,
    iconName: PropTypes.string,
    text: PropTypes.string,
    tabIndex: PropTypes.string,
    value: PropTypes.string,
    buttonForm: PropTypes.string,
    disabled: PropTypes.bool,
    isCentered: PropTypes.bool,
};
